<template>
  <section scroll-sticky :class="{ step3 }">
    <div class="j j2" data-offset="0" v-if="step3"></div>
    <div scroll-sticky-body class="stick-body" :id="id">
      <div class="cover2">
        <slot />
      </div>
    </div>
  </section>
</template>

<script>
import { applyRatio, getOffsetTop } from '@/utils';
import responsive from '@/utils/responsive';
export default {
  name: 'ScrollSticky',
  components: {},
  data() {
    return {
      bodyStyle: {},
      // coverStyle: {},
      stickContainer: null,
      stickBody: null,
      innerList: [],
      // push: 0,
      fixed: false,
    };
  },
  props: {
    img: { type: String },
    id: { default: '' },
    step3: { type: Boolean, default: false },
  },
  computed: {
    pv() {
      return this.push < 0 ? 0 : this.push > 1 ? 1 : this.push;
    }
  },
  watch: {
    sv: 'render',
  },
  methods: {
    inner(r) {
      this.push = r;
      applyRatio(this.innerList, r);
    },
    render() {
      if (!this.$el) return;
      const sv = this.sv;
      const d = sv - getOffsetTop(this.$el);
      const h = this.$el.offsetHeight - window.innerHeight;
      const sec4offsetTop = this.sec4Content.getBoundingClientRect().top;
      let scrollMoveValue;


      if (d < 0 || d > h) {
        scrollMoveValue = 0;

        if (d < 0) {
          this.copy.classList.remove('pos-bottom');
        } else if (d > h) {
          this.copy.classList.add('pos-bottom');
        }
        
        if (this.fixed) {
          this.stickContainer.style.position = 'fixed';
          this.$el.appendChild(this.stickBody);
          this.fixed = false;
          this.$store.commit('setFix', false);
          this.$emit('fixed', this.fixed);
        }
      } else {
        scrollMoveValue = sec4offsetTop + window.scrollY;
        
        if (!this.fixed) {
          this.stickContainer.style.position = 'absolute';
          this.stickContainer.appendChild(this.stickBody);
          this.fixed = true;
          this.$emit('fixed', this.fixed);
          this.$store.commit('setFix', true);
        }
      }
      
      if (d < - window.innerHeight * 2 || d > window.innerHeight * 2) return;
      this.inner(d / h);

      const t = this.sect === "sm" || this.sect === "md" ? 55 : 64;
      // const y = d > h ? h + t : t;
      const ih = h - t;

      this.bodyStyle = { height: ih + "px", marginTop: t + "px" };
      // this.imageStyle = { height: ih + "px", top: y + "px" };
      
      this.scroll.style.transform = `translateY(${scrollMoveValue}px)`;
      
    }
  },
  mounted() {
    this.stickContainer = document.querySelector('.stick-container2');
    this.stickBody = this.$el.querySelector('.stick-body');
    this.innerList = this.$el.querySelectorAll('[data-p]');
    this.sec4 = document.querySelector('.sec4');
    this.sec4Content = this.sec4.querySelector('.j');
    this.copy = this.sec4.querySelector('.copy');
    this.scroll = this.sec4.querySelector('.scroll');
    responsive.addListener(this.render);
  },
  beforeDestroy() {
    responsive.removeListener(this.render);
    this.stickBody.parentNode.removeChild(this.stickBody);
  }
};
</script>

<style lang="less">
@import "~@/less/proj";

[scroll-sticky-body] {
  .en & {
    .semi-bold;
  }
}

@media (min-width: @screen-lg-min) {
  .stick-container2 {
    .block;
    .abs;
  }

  [scroll-sticky] {
    .j {
      .abs;
      .t(100vh);
    }

    &.step3 {
      .j2 {
        .t(50vh);
      }
    }
  }

  [scroll-sticky-body] {
    .cover2 {
      z-index: 1;
      .abs;
      .wf;
      .lt;
    }
  }
}
</style>
